import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ProductVariant} from 'types/product-variant';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getCostsExports = api.injectEndpoints({
  endpoints: builder => ({
    getCostsExports: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/product-variants-with-prices`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetCostsExportsQuery} = getCostsExports;
